var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Button } from "../../button";
import { ButtonsContainer, StyledAlert, StyledAlertContent, } from "./alert.styles";
export const Alert = (_a) => {
    var { title, text, buttonFlat, buttonSecondary, closeButtonStyleType = "iconInverted", actionButtonStyleType = "secondaryInverted", reminderButtonStyleType = "flatInverted", onClick = () => { } } = _a, restProps = __rest(_a, ["title", "text", "buttonFlat", "buttonSecondary", "closeButtonStyleType", "actionButtonStyleType", "reminderButtonStyleType", "onClick"]);
    const [fade, setFade] = useState(false);
    function handleOnClick(e, eventType) {
        if (typeof onClick === "function") {
            onClick(e, eventType);
        }
        setFade(eventType === "CLOSE");
    }
    return (_jsxs(StyledAlert, Object.assign({}, restProps, { fade: fade }, { children: [_jsxs("div", { children: [_jsx("div", { children: title }), _jsx(Button, { stylingType: closeButtonStyleType, isIcon: true, symbol: "Close", onClick: (e) => {
                            handleOnClick(e, "CLOSE");
                        } })] }), _jsxs(StyledAlertContent, { children: [_jsx("div", { children: text }), _jsxs(ButtonsContainer, { children: [_jsx(Button, Object.assign({ onClick: (e) => {
                                    handleOnClick(e, "REMINDER");
                                }, stylingType: reminderButtonStyleType }, { children: buttonFlat })), _jsx(Button, Object.assign({ onClick: (e) => {
                                    handleOnClick(e, "ACTION");
                                }, stylingType: actionButtonStyleType }, { children: buttonSecondary }))] })] })] })));
};
